// extracted by mini-css-extract-plugin
export default {"lastControl":"MapWorkPlaceControls_lastControl__Is5CN"};